import basename from 'twemoji-basename';
import Icon from 'flarum/common/components/Icon';
export default function flag(language) {
  if (!language) return;
  const emoji = typeof language === 'string' ? language : language.emoji?.();
  return emoji ? m("img", {
    alt: typeof language !== 'string' && language.country?.() || '',
    className: "emoji DiscussionLanguage-flag",
    draggable: "false",
    loading: "lazy",
    src: `//cdn.jsdelivr.net/gh/twitter/twemoji@14/assets/72x72/${basename(emoji)}.png`
  }) : m(Icon, {
    name: "fas fa-globe"
  });
}
flarum.reg.add('fof-discussion-language', 'common/utils/flag', flag);